import { render } from "./HistoryDetail.vue?vue&type=template&id=1d41f0f4&ts=true"
import script from "./HistoryDetail.vue?vue&type=script&lang=ts"
export * from "./HistoryDetail.vue?vue&type=script&lang=ts"

import exportComponent from "/home/admindb/web/crevent.pedasabis.com/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__